
import { ReactElement } from 'react';
import styled from 'styled-components';
import devices from '@/utilities/devices';

// #region STYLE
const SplitWithImageContainer = styled.section<{
	backgroundImage: string;
	backgroundColor: 'beige' | 'blue' | 'prune' | 'red' | 'white' | string;
	divsSize?: number[] | null;
}>`
	background-color: ${({ theme, backgroundColor }) => {
		switch (backgroundColor) {
			case 'red':
				return theme.color.red;
			case 'beige':
				return theme.color.beige;
			case 'blue':
				return theme.color.blue;
			case 'prune':
				return theme.color.prune;
			case 'white':
				return theme.color.white;
			default:
				return backgroundColor;
		}
	}};
	color: ${({ backgroundColor, theme }) => (
		backgroundColor === 'red' || backgroundColor === 'prune' || backgroundColor === 'blue')
		? theme.color.white
		: theme.color.black};
	display: flex;
	justify-content: center;
	min-height: calc(100vh - 70px);

	> div:first-child {
		align-items: flex-start;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 0 4rem 0 10rem;
		width: ${({ divsSize }) => divsSize ? `${divsSize[0]}%` : '50%'};
	}

	> div:last-child {
		position: relative;
		width: ${({ divsSize }) => divsSize ? `${divsSize[1]}%` : '50%'};
		z-index: 0;
		background-image: url(${({ backgroundImage }) => backgroundImage });
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
	}

	@media screen and (${devices.mobile}) {
		flex-direction: column;
		min-height: auto;
		padding: 2rem 1rem;
		> div:first-child {
			align-items: center;
			padding: 0;
			width: 100%;
		}
		> div:last-child {
			display: none;
		}
		ul { padding: 0 2.5rem }
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		flex-direction: column;
		min-height: auto;
		padding: 2rem 1rem;
		> div:first-child {
			align-items: center;
			padding: 0;
			width: 100%;
		}
		> div:last-child {
			display: none;
		}
		ul { padding: 0 2.5rem }
	}

	@media screen and (${devices.min2k}) and (${devices.max2k}) {
		> div:first-child {
			width: 60rem;
		}
		> div:last-child {
			width: 60rem;
		}
	}
	@media screen and (${devices.min4k}) and (${devices.max4k}) {
		> div:first-child {
			width: 80rem;
		}
		> div:last-child {
			width: 80rem;
		}
	}
`;
// #endregion

// #region COMPONENT
const SplitWithImage = ({
	backgroundColor,
	backgroundUrl,
	children,
	divsSize,
}: {
	backgroundColor: 'beige' | 'blue' | 'prune' | 'red' | 'white' | string,
	backgroundUrl: string;
	children: ReactElement | ReactElement[] | any;
	divsSize?: number[] | null,
}) => {
	return (
		<SplitWithImageContainer
			backgroundColor={backgroundColor}
			backgroundImage={backgroundUrl}
			divsSize={divsSize}
		>
			<div>{children}</div>
			<div />
		</SplitWithImageContainer>
	);
};
// #endregion

export default SplitWithImage;
